import { Typography } from '@uhc-tempo/components';
import React from 'react';
import styles from '../../../styles/PageStyles.js';
import theme from '../../../styles/PageTheme';
import formatNumberToCurrency from '../../../utils/NumberUtil';

export default function CostProgressBar({ label, maxValue, actualValue, minValue }) {
    const minimumValue = minValue ? minValue : 0;
    const fractionalPercentage = actualValue / (maxValue - minimumValue);
    const actualPercentage = Math.round(fractionalPercentage * 100);

    const classes = styles(theme);

    const innerProgressBar = {
        height: '100%',
        width: `${actualPercentage}%`,
        backgroundColor: '#002677',
        borderRadius: 5,
        textAlign: 'right',
    };

    const stringFormattingActual = (inputActualValue) => {
        let params = {};
        if (inputActualValue % 1 == 0) {
            params = { minimumFractionDigits: 0, maximumFractionDigits: 0 };
        } else {
            params = { minimumFractionDigits: 2 };
        }
        return Number(Math.round(parseFloat(inputActualValue))).toLocaleString('en', params);
    };

    return (
        <div style={classes.fullWidthContainer} data-testid="progressbar">
            <div style={{ textAlign: 'left' }}>
                <Typography.Paragraph data-testid={label}>{`$${stringFormattingActual(
                    actualValue
                )} of ${formatNumberToCurrency(maxValue)} spent`}</Typography.Paragraph>
            </div>
            <div style={classes.outerProgressBar} data-testid="outerProgressBar">
                <div
                    id="innerProgressBar"
                    data-testid="innerProgressBar"
                    style={innerProgressBar}
                />
            </div>
            <div
                style={{
                    direction: 'row',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                }}
            >
                <div
                    style={{
                        direction: 'row',
                        alignItems: 'center',
                        display: 'flex',
                        width: `${actualPercentage}%`,
                    }}
                >
                    <div style={{ paddingRight: '8px' }}>
                        <Typography.Footnote>
                            {formatNumberToCurrency(minimumValue)}
                        </Typography.Footnote>
                    </div>
                    {actualValue !== 0 && actualValue !== '0' && actualValue !== maxValue && (
                        <div style={classes.progressText}>
                            <Typography.Paragraph
                                data-testid="outOfPocketMaxValue"
                                style={{ color: '#002677', fontWeight: 500, marginBottom: 0 }}
                            >{`$${stringFormattingActual(actualValue)}`}</Typography.Paragraph>
                        </div>
                    )}
                </div>
                <div style={{ paddingLeft: '8px' }}>
                    <Typography.Footnote>{formatNumberToCurrency(maxValue)}</Typography.Footnote>
                </div>
            </div>
        </div>
    );
}
